export enum TreatmentPendingStatusFilter {
    pendingDesign = 1,
    pendingReview = 2,
    rushPendingDesign = 3,
    rushPendingReview = 4,
    rushPendingAll = 5,
    pendingAnswer = 6,
    doctorMessagePendingReply = 7,
    expeditedPendingAll = 8,
    pendingAssign = 9,
}
